import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { OverlayModule } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { Observable } from 'rxjs';

import { QuickActionsService, QuickAction } from '../../../services/quick-actions.service';
import { HasAccessDirective } from '../../../shared/directives/has-access.directive';
import { HasOwnerDirective } from '../../../shared/directives/has-owner.directive';
import { TopbarMenuService } from '../topbar-menu.service';

/**
 * "+ New" quick-create menu (NBO-2331). Replaces the floating "+" that used to
 * sit in the legacy icon rail. Rows are grouped with captions and carry
 * accent-tinted leading entity icons — production's scanning mechanism, in the
 * redesign's style. Both the icons and the groups already live on
 * QuickActionsService, so this component only renders and dispatches.
 */
@Component({
  selector: 'app-topbar-quick-create',
  standalone: true,
  imports: [AsyncPipe, OverlayModule, TranslateModule, MatIconModule, HasAccessDirective, HasOwnerDirective],
  templateUrl: './topbar-quick-create.component.html',
  styleUrls: ['./topbar-quick-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopbarQuickCreateComponent {
  // Shared across the five clusters so only one popover is open and switching
  // between triggers takes one click (see TopbarMenuService).
  readonly open = this.menu.openFor('create');
  readonly quickActions$: Observable<QuickAction[]> = this.quickActionsService.quickActions$;

  constructor(private menu: TopbarMenuService, private quickActionsService: QuickActionsService) {}

  toggle(): void {
    this.menu.toggle('create');
  }

  close(): void {
    this.menu.close();
  }

  onBackdropClick(event: MouseEvent): void {
    this.menu.handleBackdropClick(event);
  }

  onDetach(): void {
    this.menu.closeIf('create');
  }

  run(actionId: string): void {
    this.close();
    this.quickActionsService.executeAction(actionId);
  }

  /** A group caption renders above the first row of each group. */
  startsGroup(actions: QuickAction[], index: number): boolean {
    return index === 0 || actions[index].group !== actions[index - 1].group;
  }
}
